import React from 'react';
import { Message } from 'talkplus-sdk/dist/model/types';
import TextWithLineBreaks from '@components/chat/common/textWithLineBreaks';
import ParentMessage from '@components/chat/chatDetail/messageList/parentMessage';
import useChatReactionMenu from '@components/chat/hooks/useChatReactionMenu';
import Time from '@components/chat/chatDetail/messageList/time';
import classnames from 'classnames/bind';
import styles from '../index.module.scss';

const cx = classnames.bind(styles);

interface MyMessageProps {
  message: Message;
  name?: string | undefined;
  isReplying?: boolean;
  handleReply: (message: Message) => void;
}

const MyMessage = ({ message, name, isReplying, handleReply }: MyMessageProps) => {
  const { isReaction, handleMouseEnter, handleMouseLeave, getReactionMenuEl, getReactionListEl } = useChatReactionMenu({
    message,
    isReplying,
    handleReply,
  });

  return (
    <li className={cx('messageArea', 'me', { emoji: isReaction })}>
      {name && <span className={cx('name')} />}
      <div className={cx('textArea')}>
        <Time message={message} />
        <div
          className={cx('messageArea')}
          onMouseMove={handleMouseEnter}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <ParentMessage type={'me'} id={message.parentMessageId} message={message.parentMessage} />
          <TextWithLineBreaks id={message.id} className={cx('message')} text={message.text} />
          {getReactionListEl('right')}
          {getReactionMenuEl('right')}
        </div>
      </div>
    </li>
  );
};

export default MyMessage;
